import { Grid } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import CustomTextField from "./CommonTextField";

const ReusableFormFields = React.memo(({
  inputFields,
  control,
  errors,
  register,
  setValue,
  required = false,
  defaultSize = "small",
  onFieldClick,
  gridProps = { xs: 12 },
  formReadOnly = false,
  formDisabled = false,
}) => {

  let currentTabIndex = 1;

  return (
    <Grid container spacing={2}>
      {inputFields.map((field) => {
        const isVisible = field.display !== false;
        const isReadOnly = field.readOnly !== undefined ? field.readOnly : formReadOnly;
        const isDisabled = field.disabled !== undefined ? field.disabled : formDisabled;

        if (field.type === "group") {
          return (
            <Grid
              item
              {...gridProps}
              key={field.name}
              sx={{ display: isVisible ? "block" : "none" }}
            >
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", alignItems: "center" }}
              >
                {field.fields.map((subField) => {
                  const subFieldReadOnly = subField.readOnly !== undefined ? subField.readOnly : isReadOnly;
                  const subFieldDisabled = subField.disabled !== undefined ? subField.disabled : isDisabled;
                  const subFieldTabIndex =
                    isVisible && !subFieldDisabled && !subFieldReadOnly && subField.display !== false
                      ? subField.tabIndex || currentTabIndex++
                      : -1;

                  return (
                    <Grid item xs={6} key={subField.name}>
                      <Controller
                        name={subField.name}
                        control={control}
                        rules={subField.rules || {}}
                        defaultValue={subField.defaultValue || ""}
                        render={({ field: controllerField, fieldState }) => (
                          <CustomTextField
                            {...controllerField}
                            label={subField.label}
                            type={subField.type || "text"}
                            fullWidth
                            required={subField.rules?.required || required}
                            size={subField.size || defaultSize}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message || ""}
                            startIcon={subField.startIcon}
                            endIcon={subField.endIcon}
                            options={subField.options || []}
                            placeholder={subField.placeholder || ""}
                            disabled={subFieldDisabled}
                            readOnly={subFieldReadOnly}
                            tabIndex={subFieldTabIndex}
                            maxLength={subField.maxLength}
                            showCharCount={subField.showCharCount}
                            onClick={subField.onClick}
                            loading={subField.loading}
                            loadingText={subField.loadingText}
                            noOptionsText={subField.noOptionsText}
                            onPageChange={subField.onPageChange}
                            hasNextPage={subField.hasNextPage}
                            hasPrevPage={subField.hasPrevPage}
                            onInputChange={subField.onInputChange}
                          />
                        )}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          );
        }
        
        const fieldTabIndex =
          isVisible && !isDisabled && !isReadOnly
            ? field.tabIndex || currentTabIndex++
            : -1;

        return (
          <Grid
            item
            {...gridProps}
            key={field.name}
            sx={{ display: isVisible ? "block" : "none" }}
          >
            <Controller
              name={field.name}
              control={control}
              rules={field.rules || {}}
              defaultValue={field.defaultValue || ""}
              render={({ field: controllerField, fieldState }) => (
                <CustomTextField
                  {...controllerField}
                  label={field.label}
                  type={field.type || "text"}
                  options={field.options || []}
                  fullWidth
                  required={field.rules?.required || required}
                  size={field.size || defaultSize}
                  multiline={field.multipleLine || field.name === "address"}
                  rows={field.name === "address" ? 4 : undefined}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message || ""}
                  disabled={isDisabled}
                  readOnly={isReadOnly}
                  onClick={
                    field.name === "google_map_location"
                      ? onFieldClick
                      : field.onClick
                  }
                  placeholder={field.placeholder || ""}
                  startIcon={field.startIcon}
                  endIcon={field.endIcon}
                  tabIndex={fieldTabIndex}
                  maxLength={field.maxLength}
                  showCharCount={field.showCharCount}
                  loading={field.loading}
                  loadingText={field.loadingText}
                  noOptionsText={field.noOptionsText}
                  onPageChange={field.onPageChange}
                  hasNextPage={field.hasNextPage}
                  hasPrevPage={field.hasPrevPage}
                  onInputChange={field.onInputChange}
                />
              )}
            />
          </Grid>
        );
      })}
    </Grid>
  );

});

export default ReusableFormFields;